import {forwardRef, useEffect, useState} from "react";
import {getImagePathWithTheme} from "../../utils";
import {Button, Dropdown } from "antd";
import { t } from "i18next";
import {CheckOutlined} from '@ant-design/icons';
import {getSysConfig, updateSysConfig} from "../../../model";
import {SYS_CONFIG_KEY_ORDER_BY, SYS_CONFIG_KEY_SORT_TYPE} from "../../Const";

let mSortTypeDesc = "Last viewed";

const ProjectSort = forwardRef((props:{margin:any,onRefreshData:any},ref)=>{

    const [sortMenuOpen, setSortMenuOpen] = useState(false);
    const [sortTypeDesc,setSortTypeDesc] = useState(mSortTypeDesc);
    const [sortMenu, setSortMenu] = useState([
        {
            key: "sort by",
            type: 'group',
            label: t('Sort by'),
            children: [
                {
                    key: 'sort by name',
                    label: t("alphabetical"),
                    icon: <CheckOutlined style={{color:'white',fontSize:'0px'}}/>
                },
                {
                    key: 'sort by createDate',
                    label: t('Date created')
                },
                {
                    key: 'sort by updateDate',
                    label: t('Last viewed')
                }
            ]
        },
        {
            key: "order",
            type: 'group',
            label: t('Order'),
            children: [
                {
                    key: 'date asc',
                    label: t('Oldest first')
                },
                {
                    key: 'date desc',
                    label: t('Newest first')
                }
            ]
        }
    ])

    useEffect(() => {
        updateSortStates();
    }, []);

    /*排序菜单显示状态更改*/
    const handleSortOpenChange = (nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setSortMenuOpen(nextOpen);
        }
    }

    /**排序*/
    const onSortMenuClick = (e) => {
        if ("sort by name" == e.key || "sort by createDate" == e.key || "sort by updateDate" == e.key) {
            // updateSortOrderByMenu(e.key);
            setSortMenuOpen(true);
            updateSysConfig(SYS_CONFIG_KEY_SORT_TYPE,e.key);
            //默认选中Order by 的第一个.
            if("sort by name" == e.key){
                onSortMenuClick({key:'a-z'})
            }else{
                onSortMenuClick({key:'date desc'})
            }
        } else {
            setSortMenuOpen(false);
            updateSysConfig(SYS_CONFIG_KEY_ORDER_BY,e.key);
            //更新列表
            props.onRefreshData();
        }
        updateSortStates();
    }

    /*排序状态选中*/
    const updateSortStates = async ()=>{
        let szSortType = await getSysConfig(SYS_CONFIG_KEY_SORT_TYPE);
        let szOrderBy = await getSysConfig(SYS_CONFIG_KEY_ORDER_BY);
        if(szSortType != undefined){
            szSortType = szSortType.value;
        }else{
            szSortType = "sort by updateDate";
        }
        if(szOrderBy != undefined){
            szOrderBy = szOrderBy.value;
        }else{
            szOrderBy = "date desc"
        }

        var arraySortMenus = [...sortMenu];
        if ("sort by name" == szSortType) {
            var sortMenuA = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'a-z',
                        label: 'A-Z',
                        icon: <CheckOutlined />,
                    },
                    {
                        key: 'z-a',
                        label: 'Z-A'
                    }
                ]
            }
            arraySortMenus[1] = sortMenuA;
        } else {
            var sortMenuDate = {
                key: "order",
                type: 'group',
                label: t('Order'),
                children: [
                    {
                        key: 'date asc',
                        label: t('Oldest first')
                    },
                    {
                        key: 'date desc',
                        label: t('Newest first')
                    }
                ]
            }
            arraySortMenus[1] = sortMenuDate;
        }

        var item0 = arraySortMenus[0];
        for(var i=0;i<item0.children.length;i++){
            var child = item0.children[i];

            if(child.key == szSortType){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        var item1 = arraySortMenus[1];
        for(var i=0;i<item1.children.length;i++){
            var child = item1.children[i];

            if(child.key == szOrderBy){
                child.icon = <CheckOutlined />;
            }else{
                child.icon = <CheckOutlined style={{color:'white',fontSize:'0px'}}/>;
            }
        }

        setSortMenu(arraySortMenus);
    }

    /**
     * 更新排序的描述
     * @param szSortType
     */
    const updateSortTypeDesc = (szSortType)=>{
        for(var i=0;i<sortMenu[0].children.length;i++){
            var item = sortMenu[0].children[i];
            if (item.key == szSortType){
                setSortTypeDesc(item.label);
                mSortTypeDesc = item.label;
            }
        }
    }

    return<div>
        <Dropdown overlayClassName='default-dropdown-style' overlayStyle={{minWidth: '232px'}}
                  menu={{items: sortMenu, onClick: onSortMenuClick}} trigger={['click']}
                  onOpenChange={handleSortOpenChange} open={sortMenuOpen}>
            {/*<span className='hovered' onClick={(e) => e.preventDefault()}>*/}
            {/*    <div className='flex-row-vertical-center' style={{height: '28px', padding: '0px 8px'}}>*/}
            {/*        <span className='text-color'>{sortTypeDesc}</span>*/}
            {/*        <img className='img-mini-small ml-8' style={{width: '10px', height: '9px'}}*/}
            {/*             src={getImagePathWithTheme("drop_down_home")}/>*/}
            {/*    </div>*/}
            {/*</span>*/}
            <Button type={"text"} className="small-button hovered" style={{margin: props.margin}}>
                <img className="img-16" src={getImagePathWithTheme('project_sort.svg')}/>
            </Button>
        </Dropdown>
    </div>
})

export default ProjectSort;